import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição como "de segundo plano": ela acontece sem que o usuário
 * tenha pedido nada (renovação de token, polling, heartbeat, telemetria) e por
 * isso não pode bloquear a tela com o overlay de carregamento.
 */
export const SKIP_LOADER: HttpContextToken<boolean> = new HttpContextToken<boolean>(
  () => false
);

/**
 * Força o overlay mesmo quando a requisição sai fora da janela de interação —
 * escape hatch para uma chamada de usuário que só dispara bem depois do clique
 * (um encadeamento longo, por exemplo). Vence o critério automático, mas perde
 * para o `skipLoader()`.
 */
export const FORCE_LOADER: HttpContextToken<boolean> = new HttpContextToken<boolean>(
  () => false
);

/**
 * Açúcar sintático para montar o contexto da requisição silenciosa:
 * `this.http.get(url, { context: skipLoader() })`.
 */
export function skipLoader(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_LOADER, true);
}

/**
 * `this.http.get(url, { context: forceLoader() })`.
 */
export function forceLoader(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(FORCE_LOADER, true);
}
